/**
 * VerdictBadge — the composite source-verification status pill (F6-6).
 *
 * One badge per verdict (PRD §F6-6 综合核验状态徽章). Colour comes from the
 * verdict→tone→token map; never hardcoded.
 */
import * as React from 'react';
import type { VerdictOverall } from '../../lib/veridoc-api';

import { OVERALL_LABELS } from './constants';
import { OVERALL_TONE, TONE_CLASSES } from './verdictVisual';

export function VerdictBadge({
  overall,
}: {
  overall: VerdictOverall;
}): React.JSX.Element {
  const tone = TONE_CLASSES[OVERALL_TONE[overall]];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-sm border px-2 py-0.5 text-xs font-semibold ${tone.badge}`}
    >
      <span aria-hidden="true" className={`h-1.5 w-1.5 rounded-full ${tone.dot}`} />
      {OVERALL_LABELS[overall]}
    </span>
  );
}

export default VerdictBadge;
